import path from 'path';
import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';
import {
  AddPanelBgVideo64Icon,
  ElementVideoBackgroundIcon as BackgroundVideoIcon,
} from '@packages/systems/spring';
import BackgroundVideoWrapper from './BackgroundVideoWrapper';
import BackgroundVideoPlayPauseButton, {
  DEFAULT_PLAY_PAUSE_BUTTON,
} from './BackgroundVideoPlayPauseButton';
import BackgroundVideoPlayPauseButtonPlaying from './BackgroundVideoPlayPauseButtonPlaying';
import BackgroundVideoPlayPauseButtonPaused from './BackgroundVideoPlayPauseButtonPaused';
import {BackgroundVideoWrapperType} from './dataTypes/BackgroundVideoWrapperType';
import {Plugins, ElementPreset, Component} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EList,
  EEnum,
} from '@packages/systems/wfdl-ast';

const BackgroundVideoAddPanelIcon = wrapAddPanelIcon(AddPanelBgVideo64Icon);

/*
 * Note: there is no ExpressionElement for the underlying video/BackgroundVideoVideo
 * These atoms are two React components for convenience.
 * This is one of the advantages of the atoms model: we can break the 1:1
 * coupling between element and DOM nodes.
 */

export const plugin = Plugins.PrivilegedPlugin({
  atoms: {
    BackgroundVideoWrapper,
    BackgroundVideoPlayPauseButton,
    BackgroundVideoPlayPauseButtonPlaying,
    BackgroundVideoPlayPauseButtonPaused,
  },
  dataTypes: {
    BackgroundVideoWrapper: BackgroundVideoWrapperType,
  },
  icons: {
    BackgroundVideo: BackgroundVideoIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelBackgroundVideo: BackgroundVideoAddPanelIcon,
  },
  elementPresets: {
    BackgroundVideoWrapper: ElementPreset.create({
      factory: EElement({
        id: 'Background Video Wrapper',
        type: qualify(
          Plugins.name('BackgroundVideo'),
          Component.name('BackgroundVideoWrapper')
        ),
        data: ERecord({
          tag: EEnum('div'),
          children: EList([DEFAULT_PLAY_PAUSE_BUTTON]),
          bgvideo: ERecord({
            type: EText('wrapper'),
            original_filename: EText(''),
            video_urls: EList([]),
            poster_image_url: EText(''),
          }),
          attr: ERecord({
            'data-poster-url': EText(''),
            'data-video-urls': EText(''),
            'data-autoplay': EBoolean(true),
            'data-loop': EBoolean(true),
            'data-wf-ignore': EBoolean(true),
          }),
        }),
      }),
      icon: {
        small: qualify(
          Plugins.name('BackgroundVideo'),
          iconName('BackgroundVideo')
        ),
        medium: qualify(
          Plugins.name('BackgroundVideo'),
          iconName('AddPanelBackgroundVideo')
        ),
      },
      label: 'Background Video',
      helpData: {
        description: [
          'Add a video under 30MB to a section of your site with the Background Video component. You can use MOV, WEBM, OGG, and MP4 files.',
          'To see it in action, switch to preview mode, or publish your site.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/d2/background-video.5cca514485.mp4',
      },
      category: 'Media',
    }),
  },
  siteModules: [
    {
      filePaths: [
        path.resolve(__dirname, 'objectFitPolyfill.basic.js'),
        path.resolve(__dirname, 'webflow-bgvideo.js'),
      ],
      bundleIf: {
        type: 'node',
        test: ({
          data = {},
        }: {
          data?: {
            bgvideo?: any;
          };
        }) => data.bgvideo !== undefined,
      },
    },
  ],
});
